import { observer } from 'mobx-react-lite';
import UnitCloset from './UnitCloset';
import { MAPPING_COLLAPSE } from '../../../__utils/UiConst';
import { useState } from 'react';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { Collapse } from 'antd';
import RoundedButton from '../../Globle/RoundedButton';
import { MappingIcon, UnitIcon } from '../../Globle/Icon';
import Mapping from './Mapping';

const MappingCollapse = observer(() => {
    const [activeKeys, setActiveKeys] = useState(MAPPING_COLLAPSE.MAPPING);

    const items = [
        {
            label: (
                <div className="flex items-center gap-[8px]">
                    <RoundedButton
                        icon={<MappingIcon />}
                        isActive={activeKeys === MAPPING_COLLAPSE.MAPPING}
                        className="w-[48px] h-[48px]  pointer-events-none collapse-icon-button "
                        disabled={true}
                    />
                    <h1
                        className={`font-favorit text-[20px]  leading-[28px] text-theme-black ${activeKeys === MAPPING_COLLAPSE.MAPPING ? 'font-[700]' : 'font-[400]'}`}>
                        Mapping
                    </h1>
                </div>
            ),
            key: MAPPING_COLLAPSE.MAPPING,
            children: <Mapping />,
        },
        {
            label: (
                <div className="flex items-center gap-[8px]">
                    <RoundedButton
                        icon={<UnitIcon />}
                        isActive={activeKeys === MAPPING_COLLAPSE.LIST}
                        className="w-[48px] h-[48px]  pointer-events-none collapse-icon-button  "
                        disabled={true}
                    />
                    <h1
                        className={`font-favorit text-[20px]  leading-[28px] text-theme-black ${activeKeys === MAPPING_COLLAPSE.LIST ? 'font-[700]' : 'font-[400]'}`}>
                        My Units & Closets
                    </h1>
                </div>
            ),
            key: MAPPING_COLLAPSE.LIST,
            children: <UnitCloset />,
        },
    ];
    const expandIcon = ({ isActive }) => (
        <div className="cursor-pointer">
            {isActive ? (
                <IoIosArrowUp size={20} className="text-theme-black" />
            ) : (
                <IoIosArrowDown size={20} className="text-theme-black" />
            )}
        </div>
    );
    const onChange = (key) => {
        const normalizedKey = Array.isArray(key) ? key[0] : key;
        setActiveKeys(normalizedKey);
    };
    return (
        <div className="absolute top-[8px] left-[16px] w-[460px] z-10">
            <Collapse
                bordered={false}
                className=""
                expandIcon={(panelProps) =>
                    expandIcon(
                        {
                            isActive: panelProps.isActive,
                        } || {},
                    )
                }
                rootClassName="mapping-collapse"
                accordion={true}
                expandIconPosition="end"
                collapsible="icon"
                items={items}
                activeKey={activeKeys}
                onChange={onChange}
            />
        </div>
    );
});

export default MappingCollapse;
